import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      labelAdded: formatMessage(messages.labelAdded),
      labelOffering: formatMessage(messages.labelOffering),
    };

    return { translations };
  }, [formatMessage]);

  return result;
};

export default useTranslations;
